import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

const isMobile = isMobileDevice();

export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @media (max-width: 1024px) and (orientation: landscape) {
        height: 423px;
        overflow-y: scroll;
    }
    ${media.mobileDevice`
        padding-right:3px;
        flex-wrap: unset;
        justify-content: unset;
    `};
`;

export const FilterWrapperMain = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 397px;
    height: ${({bannerHeight}) =>
        bannerHeight ? `calc(59vh - ${bannerHeight})` : '59vh'};
    align-self: center;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    overflow: scroll;
    z-index: 3000;
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
		height: 100vh;
		width: 100vw;
		max-width: none;
        overflow: scroll;
    `}

    @media screen and (min-width: 1024px ) and (max-width: 1366px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(55vh - ${bannerHeight})` : '50vh'};
    }  
    @media screen and (orientation: landscape) and (max-width: 1366px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(75vh - ${bannerHeight})` : '75vh'};
    }
    @media screen and (orientation: landscape) and (max-width: 1024px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    ////

    @media screen and (orientation: landscape) {
        ${isMobile &&
        css`
            height: 65vh;
        `}
    }
`;
